// src/components/InstalmentControl.js

import React, { memo } from 'react';
import { useInstalment } from '../../../context/InstalmentContext';
import { getStrLang } from '../../../components/Translate'; 

const InstalmentControl = memo(({ min = 1, max = 12 ,lang}) => {
    const { instalment, setInstalment, feePercentage } = useInstalment(); // Access context

    const handleInputChange = (e) => {
        let value = parseInt(e.target.value, 10);
        if (isNaN(value)) {
            value = min;
        }
        if (value < min) {
            value = min;
        }
        if (value > max) {
            value = max;
        }
        setInstalment(value);
    };

    const decreaseInstalment = () => {
        setInstalment(Math.max(min, instalment - 1));
    };

    const increaseInstalment = () => {
        setInstalment(Math.min(max, instalment + 1));
    };

    return (
        <div className='form-group'>
            <label>{getStrLang(lang.nameLang, "instalments")} {feePercentage>0 && `(${feePercentage}% ${getStrLang(lang.nameLang, "fee")})`}</label>
            <div className="d-flex align-items-center">
                <button
                    type="button"
                    onClick={decreaseInstalment}
                    className='btn btn-sm btn-light'
                    disabled={instalment <= min}
                >
                    -
                </button>
                <input
                    type="number"
                    value={instalment}
                    onChange={handleInputChange}
                    min={min}
                    max={max}
                    className="mx-2 form-control text-center"
                    style={{ width: '60px', height: '30px' }}
                />
                <button
                    type="button"
                    onClick={increaseInstalment}
                    className='btn btn-sm btn-light'
                    disabled={instalment >= max}
                >
                    +
                </button>
            </div>
        </div>
    );
});

export default InstalmentControl;
